import { STALE_TIME } from "#app/http/ReactQueryProvider";
import { fetchAddress } from "#modules/addresses/infra/fetchAddress.api";
import { queryKeys } from "#shared/queryKeys/queryKeys";

export const addressQuery = (id: string | undefined) => ({
  queryKey: queryKeys.address.detail(id),
  queryFn: () => fetchAddress(id),
  staleTime: STALE_TIME,
  enabled: !!id,
});
